import unescapedText from 'I18n/utils/unescapedText';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Small } from 'foundations-components/transitional/components/Small';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { IntegrationProductType } from '../../types/integrationProductType';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Installed = ({
  productType
}) => {
  const LABELS = {
    [IntegrationProductType.APP]: unescapedText('statusForProduct.app'),
    [IntegrationProductType.AGENT]: unescapedText('statusForProduct.agent'),
    [IntegrationProductType.CONNECTOR]: unescapedText('statusForProduct.connector'),
    [IntegrationProductType.WORKFLOW_TEMPLATE]: unescapedText('statusForProduct.workflowTemplate'),
    [IntegrationProductType.UNKNOWN]: unescapedText('statusForProduct.default')
  };
  const label = productType && Object.keys(LABELS).includes(productType) ? LABELS[productType] : unescapedText('statusForProduct.default');
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    children: [/*#__PURE__*/_jsx(IconHolder, {
      icon: SuccessIcon,
      size: "100",
      paddingInlineStart: "0",
      marginInlineStart: "0"
    }), /*#__PURE__*/_jsx(Small, {
      use: "help",
      tagName: "span",
      typography: "detail-200",
      children: label
    })]
  });
};